@if (data.items.length > 0) {
  <div class="centered-with-padding grid grid-cols-1 gap-y-6 py-7 desk:grid-cols-2 desk:gap-3">
    @for (item of data.items; track $index) {
      <a [appLink]="item.link" [openInSameTab]="item.openInSameTab" class="block h-56 desk:h-[360px]">
        <app-option-card [image]="item.image" [isPriority]="!isImageInPreviousBlocks">
          <div card-title-left>
            {{ item.title }}
            @if (item.subtitle; as subtitle) {
              <div class="text-sm font-normal">{{ subtitle }}</div>
            }
          </div>
          <div card-title-right class="h-3 w-4 desk:h-4 desk:w-6">
            <app-svg src="assets/icons/arrow-right.svg" />
          </div>
        </app-option-card>
      </a>
    }
  </div>
}
